import { roundTo } from './round-to';

/**
 * Helper to pad numbers to 2 decimal places (1 => 1.00)
 * @deprecated Use `formatNumber()` instead
 */
export const toCurrency = (n: number) => roundTo(2)(n).toFixed(2);
